import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HotToastService } from '@ngxpert/hot-toast';
import { ErrorDialogService } from '../components/Souscriptions/souscription-error/error-dialog.service';
import { AddressService } from '../services/address.service';
import { AddressApiService } from '../services/api/address-api.service';
import { AuthenticationApiService } from '../services/api/authentication-api.service';
import { BrokerApiService } from '../services/api/broker-api.service';
import { ComplementaireSanteService } from '../services/api/complementaire-sante-api.service';
import { HealthAdminApiService } from '../services/api/health/health-admin-api.service';
import { HealthQuotationApiService } from '../services/api/health/health-quotation-api.service';
import { MtxApiService } from '../services/api/mtx-api.service';
import { QuotationApiService } from '../services/api/quotation-api.service';
import { SettingApiService } from '../services/api/setting-api.service';
import { SignatureApiService } from '../services/api/signature-api.service';
import { SouscriptionEnLigneApiService } from '../services/api/souscription-en-ligne-api.service';
import { StatApiService } from '../services/api/stat-api.service';
import { SubscriptionApiService } from '../services/api/subscription-api.service';
import { BrokerService } from '../services/broker.service';
import { CarInsuranceService } from '../services/car-insurance.service';
import { ClientService } from '../services/client.service';
import { ConfigurationService } from '../services/configuration.service';
import { EmailTemplateService } from '../services/email-template.service';
import { HealthAdminService } from '../services/health-admin.service';
import { HealthInsuranceService } from '../services/health-insurance.service';
import { HealthQuotationService } from '../services/health-quotation.service';
import { HealthSignatureService } from '../services/health-signature.service';
import { HttpTunnelSanteInterceptor } from '../services/http-tunnelsante-interceptor';
import { InteractionService } from '../services/interaction.service';
import { LoggerService } from '../services/logger/logger.service';
import { QuotationCoreService } from '../services/quotation-core.service';
import { QuotationService } from '../services/quotation.service';
import { HealthRepositoryService } from '../services/repositories/health-repository.service';
import { SignatureService } from '../services/signature.service';
import { StatService } from '../services/stat.service';
import { LocalStorageService } from '../services/storage/local-storage.service';
import { SessionStorageService } from '../services/storage/session-storage.service';
import { SubscriptionService } from '../services/subscription.service';

export const wzCoreServices = [
  AuthenticationApiService,
  AddressApiService,
  AddressService,
  BrokerService,
  BrokerApiService,
  // CarPickerService,
  // CarPickerApiService,
  SubscriptionApiService,
  SubscriptionService,
  //   FileService,
  //   FileApiService,
  StatApiService,
  //   EmailJobApiService,
  //   EmailJobService,
  SignatureApiService,
  SignatureService,
  QuotationService,
  CarInsuranceService,
  HealthInsuranceService,
  HealthSignatureService,
  QuotationApiService,
  QuotationCoreService,
  ClientService,
  //   ClientDetailsService,
  //   ClientApiService,
  //   PaymentService,
  //   PaymentApiService,
  //   RefundService,
  //   RefundApiService,
  StatService,
  //   SinisterApiService,
  //   SinisterService,
  //   ReceiptApiService,
  //   RequestApiService,
  //   RequestService,
  HealthQuotationApiService,
  HealthQuotationService,
  HealthRepositoryService,
  HealthAdminService,
  HealthAdminApiService,
  SettingApiService,
  //   ReceiptApiService,
  SouscriptionEnLigneApiService,
  ComplementaireSanteService,
  ErrorDialogService,
  MtxApiService,
];

export const wzCoreMiscServices = [
  ConfigurationService,
  InteractionService,
  HotToastService,
  LoggerService,
  LocalStorageService,
  SessionStorageService,
  EmailTemplateService,
  MtxApiService,
];

export const wzCoreHttpInterceptorFactory = {
  provide: HTTP_INTERCEPTORS,
  useClass: HttpTunnelSanteInterceptor,
  multi: true,
};
